import NewClassWizard from 'modules/trainings/components/Revamp/NewClassWizard'

const ClassWizard = () => {
  return <NewClassWizard />
}

export default ClassWizard
